import { useEffect, useMemo, useRef } from "react";
import { sendWhenEpmsAnalyticsAllows } from "../utils/epmsAnalyticsReady";
import { viewedItemKey } from "../utils/viewedItems";
/**
 * Reports view_item_list when the list has loaded, and again each time the
 * set of items changes, such as after a subject change that changes them. It
 * compares with the last set only, so going from A to B and back to A reports
 * A twice. Pass null while the list is loading, and pass every item in the
 * list, before any filter, memoized on the loaded data. An empty list is not
 * reported. This counts lists loaded, not items seen - see
 * docs/analytics/gtm-ecommerce-events.md.
 */
export default function useViewItemList(list, items) {
    var _a;
    const reportedKey = useRef(null);
    const listId = (_a = list === null || list === void 0 ? void 0 : list.id) !== null && _a !== void 0 ? _a : null;
    const key = useMemo(() => listId !== null && items && items.length > 0
        ? `${listId}|${items.map(viewedItemKey).join(",")}`
        : null, [listId, items]);
    useEffect(() => {
        if (key === null || key === reportedKey.current || !list || !items) {
            return;
        }
        return sendWhenEpmsAnalyticsAllows((analytics) => {
            const delivered = analytics.onViewItemList(list, items);
            if (delivered) {
                reportedKey.current = key;
            }
            return delivered;
        });
        // The key stands for list and items, which are new objects every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
}
